.t{overflow:hidden;}